<template>
  <div id="research">
    <div class="header">
      <img v-if="$route.name === 'research'" src="~imgs/research.png" alt="研发实力">
      <img v-if="$route.name === 'cooperation'" src="~imgs/cooperation.png" alt="战略合作">
      <img v-if="$route.name === 'patent'" src="~imgs/patent.png" alt="发明专利">
    </div>
    <div v-if="$route.name === 'research'" class="research">
      <div class="item">
        <img src="~imgs/research_1.png" alt="国家CNAS认可实验室专业研发">
        <i class="line"></i>
        <div class="contxt">
          <p class="title">国家CNAS认可<br />实验室专业研发</p>
          <p>国家认证实验室专业出品，产品质量达到国际标准，为全球消费者的头皮健康保驾护航</p>
        </div>
      </div>
      <div class="item">
        <div class="contxt">
          <p class="title">为中国良方<br />注入科技力量</p>
          <p>专注头皮生态调理，精研功效产品，汲取中国良方+全球科技成分，分肤护理头皮，针对性改善26种头皮问题</p>
        </div>
        <i class="line"></i>
        <img src="~imgs/research_2.png" alt="国家CNAS认可实验室专业研发">
      </div>
      <div class="item">
        <img src="~imgs/research_3.png" alt="国家CNAS认可实验室专业研发">
        <i class="line"></i>
        <div class="contxt">
          <p class="title">双高新技术企业<br />荣获47项专利</p>
          <p>泉后研究院拥有一支高级研发工程师团队，与多所皮肤病医院和大学共同制定产品标准，拥有高达47项国家专利</p>
        </div>
      </div>
    </div>
    <div v-if="$route.name === 'cooperation'" class="cooperation">
      <div class="top"><img src="~imgs/cooperation_1.png" alt="发明专利"></div>
      <div class="center"><img src="~imgs/cooperation_2.png" alt="发明专利"></div>
    </div>
    <div v-if="$route.name === 'patent'" class="patent">
      <img src="~imgs/zhuanli.png" alt="发明专利">
    </div>

  </div>
</template>

<script>

export default {

}
</script>
<style>
#research { margin-bottom: 6rem; }
#research > div {width: 100vw;}
#research img {height: 100%; width: 100%;}
#research .header { height: 45.31vw; width: 100vw; }
#research .research { width: 81.67vw; margin: 102px auto 0; }
#research .research .item { margin-bottom: 131px; height: 32.81vw; color: #000; display: flex; align-items: center;}
#research .research .item > img {height: 32.81vw; width: 49.01vw;}
#research .research .item .line { margin-left: 2.24vw; margin-right: 1.88vw; height: 2px; width: 4.9vw; background-color: #000;}
#research .research .item .contxt {font-size: 25px; line-height: 31px;flex: 1;padding-right: 10px;}
#research .research .item .title {font-size: 54px; line-height: 61px; margin-bottom: 44px;}
#research .patent { width: 81.67vw; margin: 58px auto 0; }
#research .cooperation { width: 81.67vw; height: 101.93vw; margin: 98px auto 0; background: url(~imgs/cooperation_bg.png) top center / 66.46vw 100% no-repeat; padding-top: 9.48vw ;}
#research .cooperation .top { width: 100%; margin: auto;}
#research .cooperation .center {width: 40.78vw; margin: 3.7vw auto;}
</style>
